'use strict';
(() => {
 const initialize = () => {
  document.querySelectorAll('[data-product-rail]').forEach(rail => {
   if (rail.dataset.ready) return;
   const list = rail.querySelector('[data-merchandising-products]');
   const controls = rail.querySelector('.jmo-rail-controls');
   const previous = rail.querySelector('[data-rail-prev]');
   const next = rail.querySelector('[data-rail-next]');
   if (!list || !controls || !previous || !next) return;
   rail.dataset.ready = 'true';
   const update = () => { const maximum = list.scrollWidth - list.clientWidth; controls.hidden = maximum < 2; previous.disabled = list.scrollLeft < 2; next.disabled = list.scrollLeft >= maximum - 2; };
   const move = direction => list.scrollBy({left: direction * list.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
   previous.addEventListener('click', () => move(-1));next.addEventListener('click', () => move(1));
   list.addEventListener('scroll', update, {passive: true});new ResizeObserver(update).observe(list);update();
  });
 };
 initialize();document.addEventListener('shopify:section:load', initialize);
})();
